import './blog-card.vue__0.css?vue&type=style&scoped=true&id=b7005018&src=b7005018&lang.css';
import { defineComponent as _defineComponent } from "vue";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b7005018"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "card" };
const _hoisted_2 = { key: 0 };
const __sfc__ = _defineComponent({
    __name: 'blog-card',
    props: {
        title: {},
        description: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1 /* TEXT */),
                    (_ctx.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.description), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
//# sourceMappingURL=module.js.map


__sfc__.__scopeId = "data-v-b7005018"
export default __sfc__

//# sourceMappingURL=blog-card.vue.js.map